import React, { useEffect, useContext } from 'react';
import { PAGED_VERIFICATION_TYPES_QUERY } from '../queries';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { getListBrowserStore } from '@ts-private/list-browser';
import { ServiceContext } from 'providers/ServiceProvider';
import { Card } from '@totalsoft/rocket-ui';
import { useApolloClient } from '@apollo/client';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { useMemo } from 'react';
import VerificationTypeItem from './VerificationTypeItem';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';

export const verificationTypesStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'verificationName',
      caption: 'VerificationTypes.VerificationName',
      type: 'text'
    },
    {
      name: 'isActive',
      caption: 'VerificationTypes.IsActive',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'VerificationTypes.VerificationName',
      value: 'VerificationName'
    },
    {
      caption: 'VerificationTypes.IsActive',
      value: 'IsActive'
    }
  ],
  pager: {
    orderBy: 'VerificationName',
    direction: 'asc'
  }
});

const VerificationTypeListBrowser = () => {
  const client = useApolloClient();
  const [activeService] = useContext(ServiceContext);

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: PAGED_VERIFICATION_TYPES_QUERY,
        name: 'pagedVerificationTypes'
      }
    }),
    []
  );

  useEffect(() => {
    if (activeService) {
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'allVerificationTypes' });
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'allKindOfVerifications' });
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'allReports' });
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'pagedVerificationTypes' });
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'documentTypes' });
      client.cache.gc();
    }
  }, [activeService, client]);

  const columns = useMemo(
    () => [
      { name: 'verificationName', caption: 'VerificationTypes.VerificationName' },
      { name: 'kindOfVerification', caption: 'VerificationTypes.KindOfVerification' },
      { name: 'isActive', caption: 'VerificationTypes.IsActive', width: 15, align: 'center' },
      { name: 'actions', caption: 'Actions', width: 15 }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser
        name='verification-type-browser'
        store={verificationTypesStore}
        ItemComponent={VerificationTypeItem}
        columns={columns}
      />
      <ExportModalComponent store={verificationTypesStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={verificationTypesStore} options={fetchingOptions} />
    </Card>
  );
};

export default VerificationTypeListBrowser;
